import typography from "./shared/typography";

const themeColors = {
  green: {
    darkest: "#004700",
    dark: "#006800",
    medium: "#009200",
    light: "#7DFF7D",
    lighter: "#C7FFC7",
  },
  blue: {
    darkest: "#0033C6",
    dark: "#0033C6",
    medium: "#087BBC",
    light: "#62C2F8",
    lighter: "#E5F6FF",
  },
  orange: {
    darkest: "#5C3600",
    dark: "#B26A00",
    medium: "#F39000",
    light: "#FFBD5C",
    lighter: "#FFF1C2",
  },
  yellow: {
    darkest: "#523000",
    dark: "#B86D00",
    medium: "#FEC210",
    light: "#FFD970",
    lighter: "#FFFBC2",
  },
  neutral: {
    darkest: "#131713",
    dark: "#5E625E",
    medium: "#CDD6CC",
    light: "#EAF3EA",
    lighter: "#FCFDFC",
  },
  gray: {
    darkest: "#353535",
    dark: "#6A6A6A",
    medium: "#828282",
    light: "#DADADA",
    lighter: "#F1F1F1",
  },
  red: {
    darkest: "#741111",
    dark: "#A01717",
    medium: "#CF1E1E",
    light: "#E96868",
    lighter: "#FEF6F6",
  },
  shadows: {
    normal: "0px 4px 4px rgba(170, 208, 161, 0.42)",
    disabled: "0px 4px 4px rgba(180, 180, 180, 0.25)",
  },
  background: {
    dark: "linear-gradient(185.78deg, #000F08 4.6%, rgba(48, 48, 48, 0) 74.89%), #004833",
    normal: "#ffffff",
    light: "#F0F4F3",
  },
  white: "#ffffff",
  black: "#000000",
};

const lightTheme: Theme = {
  typography,
  colors: {
    ...themeColors,
    text: {
      primary: themeColors.green.dark,
      normal: themeColors.gray.dark,
      muted: themeColors.gray.light,
      link: themeColors.green.medium,
    },
    scrollbar: {
      thumb: "#929497",
      track: "none",
      hover: "#929497",
    },
  },
};

export default lightTheme;
